module.exports = __webpack_public_path__ + "static/purple-bg-32aa42502e6834cd22383847fbbdf950.png";